const autoNgTemplateLoaderTemplate1 = require('./createEdgeJobView.html');

import angular from 'angular';
import { CreateEdgeJobViewController } from './createEdgeJobViewController';

angular.module('portainer.edge').component('createEdgeJobView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: CreateEdgeJobViewController,
});
